import { useState } from "react";
import { getRepliesForPartner } from "../../apis";

const useGetRepliesForPartner = ({ messageId, scrollRef }) => {
  const [replies, setReplies] = useState([]);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
  });
  const [isLoading, setIsLoading] = useState(false);

  const fetchReplies = async ({ scrollToBottom = false } = {}) => {
    try {
      setIsLoading(true);
      const response = await getRepliesForPartner(messageId, 1);
      const reversed = response.data.data.reverse();

      setReplies(reversed);
      setPagination({
        current_page: response.data.meta.current_page,
        last_page: response.data.meta.last_page,
      });

      if (scrollToBottom && scrollRef?.current) {
        setTimeout(() => {
          scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }, 100);
      }
      return {
        repliesData: reversed,
        pagination: {
          current_page: response.data.meta.current_page,
          last_page: response.data.meta.last_page,
        },
      };
    } catch (error) {
      console.error("Error fetching replies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const loadMoreReplies = async () => {
    const nextPage = pagination.current_page + 1;
    if (nextPage > pagination.last_page) return;

    try {
      const response = await getRepliesForPartner(messageId, nextPage);
      const newReplies = response.data.data.reverse();
      setReplies((prev) => [...newReplies, ...prev]);
      setPagination((prev) => ({
        ...prev,
        current_page: response.data.meta.current_page,
      }));
    } catch (error) {
      console.error("Error loading more replies:", error);
    }
  };

  return {
    replies,
    pagination,
    isLoading,
    fetchReplies,
    loadMoreReplies,
    setReplies,
    setPagination,
  };
};

export default useGetRepliesForPartner;
